import { CREATE_COMMENT_SUCCESS } from '../actions/create-comment';

export default (state, action = {}) => {
  switch (action.type) {
    case CREATE_COMMENT_SUCCESS:
      return {
        ...state,
        content: {},
        image: {},
      };
    default:
      return state;
  }
};
